import { render, staticRenderFns } from "./ProvidePage.vue?vue&type=template&id=22a7bdc8&scoped=true"
import script from "./ProvidePage.vue?vue&type=script&lang=js"
export * from "./ProvidePage.vue?vue&type=script&lang=js"
import style0 from "./ProvidePage.vue?vue&type=style&index=0&id=22a7bdc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7bdc8",
  null
  
)

export default component.exports